<div class="page-container">
  <app-settings-list [items]="userOptionsList" (itemClicked)="handleItemClick($event)"></app-settings-list>
  <app-settings-list [title]="'Sonstiges'" [items]="otherOptionsList" (itemClicked)="handleItemClick($event)"></app-settings-list>
  <app-settings-list [items]="logoutList" (itemClicked)="handleItemClick($event)"></app-settings-list>

  <!-- Edit Profile -->
  <app-bottom-dialog [isVisible]="showEditProfile" [title]="'Profil bearbeiten'" (actionCancelled)="showEditProfile = false">
    <app-edit-profile *ngIf="user != null" [user]="user" (finished)="showEditProfile = false"></app-edit-profile>
  </app-bottom-dialog>
</div>